import { Button, makeStyles } from '@material-ui/core';
import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import { ERROR_MESSAGES } from '../../app/constants';
import { API } from '../../services/api';
import StoreForm from '../../components/StoreForm/StoreForm';

import 'react-phone-input-2/lib/material.css';
import TopAppBarDesktop from '../../components/common/TopAppBarDesktop';
import AddCraftsman from './AddCraftsman';

import './EditStore.css';

const useStyles = makeStyles((theme) => ({
    pageWrapper: {
        padding: '10px',
    },
}));

export default function EditStore() {
    const history = useHistory();
    const btnRedirect = () => history.push('/stores');
    const classes = useStyles();

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors: formHookErrors },
    } = useForm({ creditAccounts: true });
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otherErrorsMsg, setOtherErrorsMsg] = useState('');
    const [storeData, setStoreData] = useState(null);
    const { id } = useParams();

    const fetchData = async () => {
        const storeData = await API.getStoreDetails(id);
        setStoreData(storeData);
    };

    useEffect(() => {
        if (storeData) {
            setValue('contactPerson', storeData.contactPerson);
            setValue('name', storeData.name);
            setValue('creditAccounts', storeData.creditAccounts);
            setValue('uic', storeData.uic);
            setValue('url', storeData.url);
            setPhoneNumber(storeData.contactPhone.substring(1));
        }
    }, [storeData]);

    useEffect(() => {
        fetchData();
    }, []);

    const submitHandler = async (data) => {
        if (!phoneNumber) {
            setOtherErrorsMsg(ERROR_MESSAGES.PHONE);
        }

        const submitData = {
            ...data,
            contactPhone: `+${phoneNumber}`,
            securityToken: storeData.securityToken,
            id,
        };

        try {
            await API.editStore(submitData);
            history.push('/stores');
        } catch (err) {
            console.log('register store error', err);
            setOtherErrorsMsg(err.response?.data?.message);
        }
    };

    const getErrorMessage = () => {
        let msg = '';
        const errorKeys = Object.keys(formHookErrors);

        if (!!errorKeys.length) {
            const firstError = errorKeys[0];
            msg = formHookErrors[firstError].message;
        }

        if (otherErrorsMsg) {
            msg = otherErrorsMsg;
        }

        return msg;
    };

    const errorMessage = getErrorMessage();

    if (!storeData) {
        return null;
    }

    return (
        <div className={classes.pageWrapper}>
            <TopAppBarDesktop />
            <Stack flexDirection={'row'} justifyContent={'end'}>
                <Stack flexDirection={'row'} gap={'10px'}>
                    <AddCraftsman />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={btnRedirect}
                    >
                        Back
                    </Button>
                </Stack>
            </Stack>
            <StoreForm
                register={register}
                handleSubmit={handleSubmit(submitHandler)}
                errorMessage={errorMessage}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                setOtherErrorsMsg={setOtherErrorsMsg}
                isEdit={true}
                creditAccountsValue={storeData.creditAccounts}
            />
        </div>
    );
}
